import api from "@/services/api.js";
import C from "@/utils/constants";
import crypto from "@/utils/crypto.js";

export default {
  login({ commit }, auth) {
    commit("toggleIsAuthing");
    commit("setToggleIsReAuthing", false);
    let clientId = "oauthclient";

    if (C.AGENT_DOMAINS.includes(window.location.hostname)) {
      clientId = "oauthagents";
    }
    return api.auth
      .login(auth.email, auth.password, clientId)
      .then((resp) => {
        console.log("auth refresh...");
        console.log(process.env.VUE_APP_AUTH_REFRESH);
        console.log(".....");

        if (process.env.VUE_APP_AUTH_REFRESH === "USER_PASS") {
          console.log("store creds...");
          let creds = {
            email: auth.email,
            password: crypto.encrypt(auth.password),
          };
          commit("setCreds", creds);
        }

        commit("setSession", resp.data);
        commit("toggleIsAuthing");

        this.dispatch("auth/calculateSessionExpiration");

        return resp;
      })
      .catch((e) => {
        commit("toggleIsAuthing");
        throw e;
      });
  },
  loginWithCode({ commit }, auth) {
    commit("toggleIsAuthing");
    commit("setToggleIsReAuthing", false);
    return api.auth
      .loginWithCode(auth.code, auth.codeVerifier)
      .then((resp) => {
        commit("setSession", resp.data);
        commit("toggleIsAuthing");

        this.dispatch("auth/calculateSessionExpiration");

        return resp;
      })
      .catch((e) => {
        commit("toggleIsAuthing");
        throw e;
      });
  },
  reAuth({ commit, state, rootGetters }) {
    if (!state.isReAuthing) {
      console.log("do reauth....");
      commit("setToggleIsReAuthing", true);
      // token refresh
      const isAgent = rootGetters["user/isAgent"];
      console.log(isAgent);
      let clientId = isAgent ? "oauthagents" : "oauthclient";
      // let clientId = "oauthclient";
      console.log("What is the client id here: ", clientId);
      return api.auth
        .refresh(state.session.refresh_token, clientId)
        .then((resp) => {
          console.log("....refreshing auth token....");
          console.log(resp.data);
          console.log("....refresh done....");

          let session = state.session;
          if (resp.data && resp.data.access_token) {
            session.access_token = resp.data.access_token;
          }
          if (resp.data && resp.data.refresh_token) {
            session.refresh_token = resp.data.refresh_token;
          }
          if (resp.data && resp.data.token_type) {
            session.token_type = resp.data.token_type;
          }
          if (resp.data && resp.data.expires_in) {
            session.expires_in = resp.data.expires_in;
          }

          console.log("...should be setting the session....");
          commit("setSession", session);
          commit("setToggleIsReAuthing", false);
          console.log("...should have set the session....");
          this.dispatch("auth/calculateSessionExpiration");
          return resp;
        })
        .catch((e) => {
          console.log("token refresh error...");
          // set access token to null if refresh fails to log user out
          commit("setCreds", null);
          commit("setSession", { access_token: null, refresh_token: null });
          commit("setCodeChallenge", null);
          commit("setToggleIsReAuthing", false);
          throw e;
        });
      // }
    } else {
      return new Promise((resolve) => {
        resolve("ok");
      });
    }
  },
  autoAuth() {
    console.log("autoAuthing...");
    this.dispatch("auth/reauth");
  },
  logout({ commit }) {
    return new Promise((resolve) => {
      console.log("clearing auth creds...");
      commit("setCreds", null);
      commit("setSession", { access_token: null, refresh_token: null });
      commit("setCodeChallenge", null);
      commit("setToggleIsReAuthing", false);
      api.auth.logout();
      resolve("logged out...");
    });
  },
  calculateSessionExpiration({ commit }) {
    let exp = new Date();
    // exp.setSeconds(exp.getSeconds() + 3600);
    // per slack convo, exp window is now 5 min, so lets set it to 4.75 min on front-end
    exp.setSeconds(exp.getSeconds() + 285);
    commit("setSessionExpiration", exp);
  },
  impersonateBrokerage({ commit }, brokerage) {
    let params = {
      brokerId: brokerage.id,
      pageIndex: 0,
      pageSize: 1,
      roleName: C.RoleBrokerAdmin,
      active: true,
    };

    return api
      .getUsers(params)
      .then((resp) => {
        if (resp.data.content) {
          if (resp.data.content.length > 0) {
            commit("setImpBrokerage", brokerage);
            commit("setImpUser", resp.data.content[0]);

            return true;
          }
        }

        return false;
      })
      .catch((e) => {
        throw e;
      });
  },
  clearImpersonate({ commit }) {
    commit("setImpBrokerage", null);
    commit("setImpUser", null);
    commit("setImpLoanOffice", null);
  },
  impersonateLoanOffice({ commit }, loanOffice) {
    let params = {
      loanOfficeId: loanOffice.id,
      pageIndex: 0,
      pageSize: 1,
      roleName: C.RoleLenderAdmin,
      active: true,
    };

    return api
      .getUsers(params)
      .then((resp) => {
        if (resp.data.content) {
          if (resp.data.content.length > 0) {
            console.log("Loan Office Impersonation....");
            commit("setImpLoanOffice", loanOffice);
            commit("setImpUser", resp.data.content[0]);

            return true;
          }
        }

        return false;
      })
      .catch((e) => {
        throw e;
      });
  },
};
